import { memo } from 'react';

interface TaskBoxWeekBadgesProps {
  effectiveWeeks: number;
  baseWeeks: number | null;
  bestCaseWeeksRounded: number | null;
  isMultitasking: boolean;
}

export const TaskBoxWeekBadges = memo(function TaskBoxWeekBadges({
  effectiveWeeks,
  baseWeeks,
  bestCaseWeeksRounded,
  isMultitasking,
}: TaskBoxWeekBadgesProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
      {bestCaseWeeksRounded !== null && bestCaseWeeksRounded < effectiveWeeks && (
        <span
          style={{
            fontSize: 9,
            backgroundColor: 'rgba(52, 211, 153, 0.8)',
            padding: '1px 4px',
            borderRadius: 3,
          }}
          title="Best Case"
        >
          {bestCaseWeeksRounded}w
        </span>
      )}
      <span
        style={{
          fontSize: 9,
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          padding: '1px 4px',
          borderRadius: 3,
        }}
      >
        {effectiveWeeks}w
        {isMultitasking && baseWeeks && (
          <span style={{ marginLeft: 4, textDecoration: 'line-through', opacity: 0.7 }}>
            {baseWeeks}w
          </span>
        )}
      </span>
    </div>
  );
});
